import { Outlet } from '@tanstack/react-router'

export function PatientLayout() {
  return (
    <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8'>
      <Outlet />
    </div>
  )
}

